export function setCookie (name, value, days = 1) {
  let expires = ''
  if (days) {
    let date = new Date()
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000))
    expires = '; expires=' + date.toUTCString()
  }
  document.cookie = name + '=' + (value || '') + expires + ';domain=' + getCookieDomain() + '; path=/'
}

export function getCookie (name) {
  let nameEQ = name + '='
  let ca = document.cookie.split(';')
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i]
    while (c.charAt(0) === ' ') c = c.substring(1, c.length)
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length)
  }
  return null
}

export function eraseCookie (name) {
  document.cookie = name + '=; Domain=' + getCookieDomain() + ' Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;'
}

export function getCookieDomain () {
  let domain = window.location.hostname
  if (domain.endsWith('socialhp.com')) {
    domain = '.socialhp.com'
  } else if (domain.endsWith('socialhp.dev')) {
    domain = '.socialhp.dev'
  }
  return domain
}
